import React from 'react';
import { LABEL, CUSTOM_MESSAGES } from "../../../veriables";
import cn from "classnames";
import { ReactComponent as ExpandMore } from "@assets/images/expand_more.svg";
import { ReactComponent as LightExpandMore } from "@assets/images/light_expand_more.svg";
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import NotesIcon from '@assets/images/NotesIcon';
import { ReactComponent as Edit } from "@assets/images/edit/edit.svg";
import { ReactComponent as DeleteIcon } from "@assets/images/delete.svg";
import styles from "../serverAppPaymentScreens.module.scss";
import style from "./index.module.scss";

const SplitBySeatPortrait = ({
  serverAppTheme,
  serverAppThemeNumber,
  tableData,
  seatDataToDisplay,
  seatList,
  availableSeats,
  selectedStage,
  isDisplayItems,
  addToSeatList,
  getSeatItems,
  checkSplitStatus,
  toggleDisplayItems,
  addStage,
  handleStageSelection,
  removeWithPaymentStages,
  handleOpenEditModal,
  handleOpenDeleteModal,
  setIsEditModalOpen,
  handlePayment,
  setSingleLoyalty,
  setSeatDataToDisplay,
  renderModifier,
}) => {
  return (
    <>
      <div className="col-12 p-0 pt-2 h-100">
        <div className={cn("col-12 px-0 d-flex")}>


          <div className="col-4 px-0 pr-1">
            <TouchableButton
              type="button"
              className={cn(
                style.btnAddStyle,
                "fs_12 btn-secondary btn-ripple text-center w-100 rounded",
              )}
              onClick={(e) => {
                e.preventDefault();
                handleOpenEditModal();
              }}
              aria-label="plusBtn"
              rippleEffect={true}
            >
              {LABEL().ADD}
            </TouchableButton>
          </div>
          <div className="col-5 px-0 pr-1">
            <TouchableButton
              type="button"
              onClick={(e) => {
                e.preventDefault();
                handleOpenDeleteModal();
              }} className={cn(
                style.btnDelStyle,
                "btn-ripple text-center rounded color-white w-100 fs_12",
              )}
              style={{ backgroundColor: serverAppTheme?.primaryBtn }}
              rippleEffect={true}
            >
              {LABEL().DELETE_SEAT_TITLE}
            </TouchableButton>
          </div>
          <div className="col-3 d-flex justify-content-end px-0">
            <TouchableButton
              type="button"
              className={cn("btn44 btn-ripple w-75 h-100")}
              onClick={(event) => {
                event.preventDefault();
                handlePayment(true);
              }}
              style={{
                color: serverAppTheme?.btn_font_color,
                backgroundColor: serverAppTheme?.primaryBtn,
                borderRadius: "4px",
                border: "none",
                fontSize: "12px",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              rippleEffect={true}
            >
              {LABEL().SAVE}
            </TouchableButton>
          </div>

        </div>
        <div
          className={cn("d-flex flex-column justify-content-between h-25")}
        >
          <div
            className={cn(cn("text-left fs_12 fw-500 pt-2"))}
            style={{ color: serverAppTheme?.primary_text }}
          >
            {CUSTOM_MESSAGES().SBSS_SELECT_SEAT_AND_CREATE_CHECKS}
          </div>
          <div className={cn("fs-12 d-flex flex-column justify-content-around align-items-center h-45")}>
            <div
              className={cn("d-flex flex-wrap w-100 m-0 p-0 overflowY")}
            >
              {tableData?.seats?.filter((e) => e?.open)?.length > 0 &&
                tableData?.seats?.map((el, index) => {
                  return (
                    checkSplitStatus(el) &&
                    !availableSeats.includes(el.id) &&
                    el.open && (
                      <TouchableButton
                        key={index}
                        className={cn(
                          "px-0 rounded btn-ripple mb-1 btn50 d-flex justify-content-center align-items-center fs_12 fw-600",
                        )}
                        onClick={() => {
                          addToSeatList(el.id);
                          getSeatItems(el.id, el.number);
                        }}
                        style={{
                          marginRight: "1.5%",
                          width: "40px",
                          height: "44px",
                          color: seatList.includes(el.id)
                            ? serverAppTheme?.seat_box_text
                            : serverAppTheme?.btn_font_color,
                          background: seatList.includes(el.id)
                            ? serverAppTheme?.Category_text
                            : serverAppTheme?.seat_tiles,
                          border: `1px solid ${serverAppTheme?.stage_seat_border}`,
                          outline: 'none'
                        }}
                      >
                        {el.number}
                      </TouchableButton>
                    )
                  );
                })}
            </div>
          </div>
          <div
            className={cn("fs_16 h-10 d-flex justify-content-between mt-1")}
          >
            <div className={cn("col-12 px-0 h-100 mb-1 d-flex align-items-end")}>
              <TouchableButton
                className={cn(
                  "btn44 fw-500 px-0 rounded btn-ripple fs_16 d-flex align-items-center justify-content-center",
                  style.createCheck,
                )}
                onClick={() => {
                  const newStage = addStage();
                  setSeatDataToDisplay([]);
                  if (newStage) {
                    handleStageSelection(newStage);
                  }
                }}
                style={{
                  height: "32px",
                  width: "262px",
                  color: serverAppTheme?.btn_font_color,
                  backgroundColor: serverAppTheme?.primaryBtn,
                }}
                rippleEffect={true}
              >
                {LABEL().SBSS_CREATE_CHECK}
              </TouchableButton>
            </div>
          </div>
        </div>
        <div
          className={cn(
            "d-flex justify-content-center align-items-center pt-1 mt-1 w-100",
          )}
        >
          <div
            className={cn(
              "h-95 overflowY overflowXHidden border-color-primary justify-content-center py-2",
              style.previewItems,
            )}
            style={{
              background: serverAppTheme?.splitSelectedTile,
              height: '115px'
            }}
          >
            {seatDataToDisplay?.length > 0 ? (
              seatDataToDisplay?.map((check, index) => {
                const seat = tableData?.seats?.find(
                  (e) => e?.id === check?.seatId,
                );
                return (
                  <div
                    className="fw-500"
                    key={check?.seatId ?? `seat-${index}`}
                  >
                    <div className="d-flex justify-content-center pt-1 px-2">
                      <div
                        className={cn(
                          "col-12 row mx-0 fs_16 rounded pl-2 pt-1 pr-0",
                          style.seatItemsDisplay,
                        )}
                        style={{
                          background: serverAppTheme?.seatItemsDisplay,
                          border: serverAppTheme?.seatItemsDisplayBorder,
                        }}
                      >
                        <div className="col-10 px-0">
                          Seat {check?.seatNumber}
                          {seat?.name ? (
                            <span className="ml-1">
                              (
                              <span
                                className={cn(styles.truncate2, "m-0 p-0")}
                              >
                                {seat?.name}
                              </span>
                              )
                            </span>
                          ) : (
                            seat.name
                          )}
                        </div>
                        <TouchableDiv
                          className="col-2 px-0 d-flex rounded align-items-center justify-content-center"
                          style={{
                            width: "2rem",
                            height: "2rem",
                            outline: 'none'
                          }}
                          tabIndex="0"
                          role="button"
                          onClick={(event) => {
                            event.stopPropagation();
                            toggleDisplayItems(check?.seatId);
                          }}
                        >
                          {serverAppThemeNumber == 2 ? (
                            <LightExpandMore
                              className="mb-2"
                              role="presentation"
                              fill={serverAppTheme?.iconcolor}
                              alt="back"
                              style={{
                                height: "80%",
                                transform:
                                  isDisplayItems[check?.seatId] &&
                                  "rotate(180deg)",
                              }}
                            />
                          ) : (
                            <ExpandMore
                              className="mb-2"
                              role="presentation"
                              fill={serverAppTheme?.iconcolor}
                              alt="back"
                              style={{
                                height: "80%",
                                transform:
                                  isDisplayItems[check?.seatId] &&
                                  "rotate(180deg)",
                              }}
                            />
                          )}
                        </TouchableDiv>
                      </div>
                    </div>
                    {isDisplayItems[check?.seatId] && (
                      <>
                        {check?.seatItems?.length > 0 && (
                          <div
                            className="col-12 h-10 fs_12 fw-500 px-3 row mx-0 py-1"
                            style={{ color: serverAppTheme?.itemQtyClr }}
                          >
                            <div className="col-9 px-0">Items</div>
                            <div className="col-3 px-0 text-right">
                              Amount
                            </div>
                          </div>
                        )}
                        {check?.seatItems?.map((items) => {
                          return (
                            <div className="px-3 fs_12">
                              <div className="row px-0 mx-0">
                                <div className="col-9 p-0 m-0">
                                  {items?.menuItemName}
                                </div>
                                <div className="col-3 px-0 text-right">
                                  {LABEL().CURRENCY_SYMBOL}
                                  {(items?.splitAmount || 0)?.toFixed(2)}
                                </div>
                              </div>
                              <div
                                className="col-12 px-0"
                                role="presentation"
                              >
                                {items.modifiers &&
                                  items.modifiers.length > 0 &&
                                  renderModifier(items.modifiers)}
                                {(items.note || items.comment) && (
                                  <div style={{ color: serverAppTheme?.noteColor }} className={cn("col-12 row mx-0 px-0 fs_12")}>
                                    <span className='col-1 px-0'>
                                      <NotesIcon />
                                    </span>
                                    <span className={cn('pl-2 col-11 pr-0')}>
                                      {items.note || items.comment}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                );
              })
            ) : (
              <div
                className={cn(
                  "col-12 h-100 fs_12 d-flex justify-content-center align-items-center fw-400 text-center px-2",
                )}
                style={{ color: serverAppTheme?.noItemContainers }}
              >
                {CUSTOM_MESSAGES().SBSS_SELECT_SEAT_TO_PREVIEW_ITEMS}
              </div>
            )}
          </div>
        </div>
        <div className={cn("col-12 overflowY mt-3 pl-0 pr-0 h-53")}>
          {tableData?.splits &&
            Object.values(tableData.splits).length > 0 &&
            Object.values(tableData.splits)?.map((el) => {
              return (
                Number(el.status) === 0 && (
                  <TouchableDiv
                    key={el.id}
                    className={cn(
                      "mb-2 fs_16 px-2 d-flex flex-column justify-content-around rounded",
                    )}
                    style={{
                      minHeight: "100px",
                      background:
                        selectedStage === el.id
                          ? serverAppTheme?.selected
                          : serverAppTheme?.splitUnselectedTile,
                      color: serverAppTheme?.primary_text,
                      outline: 'none'
                    }}
                    tabIndex="0"
                    role="button"
                    onClick={() => {
                      handleStageSelection(el);
                    }}
                  >
                    <div
                      className="d-flex justify-content-between align-items-center fs_16 fw-500"
                      style={{ color: serverAppTheme?.primary_text }}
                    >
                      <div className="col-10 px-0">
                        {LABEL().SBSS_CHECK}: {el?.number}{" "}
                        {el?.name?.length > 0 && (
                          <span>
                            <span
                              className={cn(
                                styles.truncate,
                                styles.truncateWidth5,
                              )}
                            >
                              {el.name}
                            </span>
                          </span>
                        )}
                      </div>
                      <div className="mr-2 col-2 px-0 d-flex justify-content-end">
                        <TouchableButton
                          className="rounded d-flex justify-content-center align-items-center h-100 py-1"
                          style={{
                            backgroundColor:
                              serverAppTheme?.mod_group_name_bg,
                            border: serverAppTheme?.select_border,
                          }}
                          onClick={(event) => {
                            event.preventDefault();
                            setIsEditModalOpen({
                              isEditOpen: true,
                              data: el,
                              seatId: el?.id,
                            });
                          }}
                          rippleEffect={true}
                        >
                          <Edit
                            fill={serverAppTheme?.iconcolor}
                            width={"12px"}
                          />
                        </TouchableButton>
                      </div>
                    </div>
                    <div
                      className="rounded fw-500 fs_16"
                    >
                      <span className='mr-1'>Seat: </span>
                      <span className=''>
                        {
                          el?.seats?.map((seatEl, seatIndex, seatArray) => {
                            const seat = tableData?.seats?.find((e) => e.id === seatEl?.seatId);
                            return seat && (
                              <span key={seat.id}>
                                {seat.name ? (
                                  <span className={cn(styles.truncate, 'm-0 p-0')}>
                                    {seat.name}({seat.number})
                                  </span>
                                ) : seat.number}
                                {seatArray.length > 1 && seatIndex < seatArray.length - 1 && ', '}
                              </span>
                            );
                          })
                        }
                      </span>
                    </div>
                    <div className="row mx-0 col-12 px-0 fw-500">
                      <div className="col-10 px-0">
                        {el.totalAmount != null
                          ? `${LABEL().CURRENCY_SYMBOL}${Number(el.totalAmount).toFixed(2)}`
                          : ""}
                      </div>
                      <div className="d-flex justify-content-end col-2 px-0">

                        <div>
                          <TouchableButton
                            type="button"
                            className={cn(
                              style.checkDelStyle,
                              "col fs-20  btn-ripple text-center py-0 px-0 rounded",
                            )}
                            style={{
                              backgroundColor:
                                serverAppTheme?.mod_group_name_bg,
                              border: serverAppTheme?.select_border,
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              setSingleLoyalty(null);
                              removeWithPaymentStages(el);
                            }}
                            rippleEffect={true}
                          >
                            <DeleteIcon
                              fill={serverAppTheme?.iconcolor}
                              width={"12px"}
                            />
                          </TouchableButton>
                        </div>
                      </div>
                    </div>
                  </TouchableDiv>
                )
              );
            })}
        </div>
      </div>
    </>
  )
}
export default SplitBySeatPortrait;